/**
 * External Links Configuration
 *
 * Centralized config for all external service links.
 * Update CALENDLY_URL after setting up your Calendly account.
 */

export const EXTERNAL_LINKS = {
  // Calendly booking link
  calendly: {
    // Main consultation booking link
    url: 'https://calendly.com/hello-nripathfinder/30min',

    // Event name for display
    eventName: 'NRI Tax Consultation',

    // Duration in minutes
    duration: 30,
  },

  // Substack newsletter
  newsletter: 'https://nri2india.substack.com/',

  // Contact email
  contactEmail: 'hello@nripathfinder.com',
} as const;

/**
 * Generate Calendly URL with pre-filled email
 * Calendly supports pre-filling guest email via URL parameter
 */
export function getCalendlyUrlWithEmail(email?: string): string {
  const baseUrl = EXTERNAL_LINKS.calendly.url;

  if (email) {
    // Calendly accepts email pre-fill via query param
    const encodedEmail = encodeURIComponent(email.trim().toLowerCase());
    return `${baseUrl}?email=${encodedEmail}`;
  }

  return baseUrl;
}

/**
 * Generate Calendly URL with pre-filled name and email
 */
export function getCalendlyUrlWithDetails(name?: string, email?: string): string {
  const baseUrl = EXTERNAL_LINKS.calendly.url;
  const params = new URLSearchParams();

  if (email) {
    params.set('email', email.trim().toLowerCase());
  }

  if (name) {
    params.set('name', name.trim());
  }

  const queryString = params.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
